<!--
    描述：平台制度 主页面
    时间：2020-10-28
    Created by ws
-->

<template>
	<div class="h100">
		<filter-layout @search="doSearch" @reset="doRefresh">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="100px" :model="searchObj">
					<el-form-item label="制度名称：" prop="sname">
						<el-input v-model="searchObj.sname" placeholder="请输入" size="small" clearable></el-input>
					</el-form-item>
					<el-form-item label="制度类型：" prop="type">
						<el-select v-model="searchObj.type" placeholder="请选择" size="small" clearable>
							<el-option
								v-for="(item, index) in rulesList[0].children"
								:key="'类型1' + index"
								:label="item.sname"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布人：" prop="publisher">
						<el-input v-model="searchObj.publisher" placeholder="请输入" size="small" clearable></el-input>
					</el-form-item>
					<el-form-item label="发布时间：" prop="dateArr" class="date-width">
						<el-date-picker
							v-model="searchObj.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							:picker-options="endDatePicker"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 头部按钮 -->
				<div class="content-header">
					<div class="title">
						合计平台制度：<span class="blue">{{ totalResult }}</span> 条
					</div>
					<div class="btnGroups">
						<el-button v-if="roleBtns.includes('platformSystem-add')" class="btn-success" size="small" @click="doAdd">新增</el-button>
						<el-input
							size="small"
							class="input-width hidden"
							v-model="searchObj.sname"
							@keyup.enter.native="doSearch('1')"
							placeholder="请输入相关制度名称..."
						>
							<template slot="append">
								<el-button size="small" icon="el-icon-search" class="btn-append" @click="doSearch('1')"></el-button>
							</template>
						</el-input>
						<el-button size="small" class="btn-blue" icon="el-icon-refresh" type="primary" @click="doRefresh"></el-button>
					</div>
				</div>
				<!-- 表格内容 -->
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table
							:data="tableData"
							border
							resizable
							height="100%"
							size="small"
							highlight-current-row
							highlight-hover-row
							:loading="loading"
							show-overflow="tooltip"
							show-header-overflow="tooltip"
						>
							<vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
							<vxe-table-column field="sname" title="制度名称" show-overflow header-align="center" min-width="180"></vxe-table-column>
							<vxe-table-column field="applySysName" title="应用业务" align="center" min-width="150"></vxe-table-column>
							<vxe-table-column field="applyRoleName" title="应用对象" show-overflow align="center" min-width="180"></vxe-table-column>
							<vxe-table-column field="typeName" title="制度类型" align="center" min-width="150"></vxe-table-column>
							<vxe-table-column field="publisher" title="发布人" align="center" min-width="150"></vxe-table-column>
							<vxe-table-column field="createDate" title="发布时间" sortable align="center" min-width="150"></vxe-table-column>
							<vxe-table-column title="状态" width="100" align="center">
								<template v-slot="{ row }">
									<vxe-switch
										:value="row.isFlag"
										open-label="启用"
										close-label="禁用"
										:open-value="1"
										:close-value="0"
										:class="{
											opacityHide: !roleBtns.includes('platformSystem-enable')
										}"
										@click.native.prevent="handleSwitch(row)"
									></vxe-switch>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作" min-width="160">
								<template v-slot="{ row }">
									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('platformSystem-edit')"
										@click="doEdit(row)"
									>
										<svg-icon icon-class="form-edit"></svg-icon> 编辑
									</el-button>
									<el-button
										type="danger"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('platformSystem-del')"
										icon="el-icon-delete"
										@click="doDelete(row)"
										>删除
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<vxe-pager
							size="mini"
							:current-page="currentPage"
							:page-size="pageSize"
							:total="totalResult"
							class="text-center"
							:page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
							:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', , 'FullJump']"
							@page-change="handlePageChange"
						>
						</vxe-pager>
					</div>
				</div>
			</template>
		</filter-layout>
		<!-- 新增弹窗 -->
		<el-dialog
			:title="dialogObj.title"
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:close-on-click-modal="false"
			:fullscreen="true"
			custom-class="h100-dialog"
			center
			@closed="handleClosed"
		>
			<el-form :model="ruleForm" ref="ruleForm" v-if="dialogObj.visible" :rules="formRules" :show-message="false" label-width="120px">
				<el-form-item label="制度名称" prop="sname">
					<el-input v-model="ruleForm.sname"></el-input>
					<!-- @keyup.native="
			   ruleForm.sname = ruleForm.sname.replace(
				   /[^\w\u4E00-\u9FA5]/g,
				   ''
			   )
		   " -->
				</el-form-item>
				<el-form-item label="制度类型" prop="type">
					<el-select v-model="ruleForm.type">
						<el-option
							v-for="(item, index) in rulesList[0].children"
							:key="'类型' + index"
							:label="item.sname"
							:disabled="ruleForm.disabled"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用业务" prop="applySysList">
					<el-select v-model="ruleForm.applySysList" multiple @remove-tag="removeTag">
						<el-option v-for="(item, index) in rangeList" :key="'业务' + index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用对象" prop="applyRoleList">
					<el-select v-model="ruleForm.applyRoleList" multiple>
						<el-option-group v-for="group in filterRange" :key="group.label" :label="group.label">
							<el-option v-for="item in group.children" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<wang-editor v-model="ruleForm.content" ref="wangEditor" height="100%"></wang-editor>
				</el-form-item>
				<el-form-item label="附件">
					<public-upload ref="upload" tableName="operate_sys_regime" assortment="zd_upload" :aid="ruleForm.id" :needRefresh="false"></public-upload>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" @click="doSubmit">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	deleteRegime,
	getRange,
	insertOrUpdateRegime,
	selectRegimePage,
	setAgreementStatusPt,
} from '@/api/modules/rulesManagement'
import { mapState } from 'vuex'

export default {
	data() {
		return {
			treeProps: {
				label: 'sname'
			},
			searchToggle: true,
			splitV: 0.2,
			tableData: [],
			currentPage: 1,
			pageSize: 10,
			totalResult: 0,
			loading: false,
			searchObj: {
				// curRuleType: '',
				sname: '',
				type: '',
				publisher: '',
				startDate: '',
				endDate: ''
			},
			dialogObj: {
				title: '新增',
				visible: false,
				width: '850px',
				mode: 'add'
			},
			ruleForm: {
				disabled: false,
				sname: '', // 名称
				type: '', // 类型
				applyRole: '', // 应用对象
				applyRoleList: [], // 应用对象数组
				applySys: '', // 应用业务
				applySysList: [], // 应用业务数组
				content: '' // 内容
			},
			formRules: {
				sname: [{ required: true }],
				type: [{ required: true }],
				applyRoleList: [{ required: true, type: 'array' }],
				applySysList: [{ required: true, type: 'array' }],
				content: [{ required: true }]
			},
			rangeList: [], // 应用范围
			startDatePicker: this.beginDate(),
			endDatePicker: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				}
			}
		}
	},
	created() {
		this.doSearch()

		this.getRangeList()
	},
	methods: {
		// 左侧协议制度树 节点点击
		handleNodeClick(data, node) {
			this.searchObj.curRuleType = data.value
			this.ruleForm.type = data.value
			this.ruleForm.disabled = data.value === '' ? false : true
			this.doSearch()
		},

		// 应用业务移除tag
		removeTag(val) {
			this.rangeList.find((y) => {
				if (y.value === val) {
					let arr = y.children
					arr.map((x) => {
						let item = this.ruleForm.applyRoleList.findIndex((z) => z === x.value)
						if (item > -1) {
							this.ruleForm.applyRoleList.splice(item, 1)
						}
					})
				}
			})
		},

		// 点击切换状态
		handleSwitch(row) {
			if (this.roleBtns.includes('platformSystem-enable')) {
				let _flag = row.isFlag == 0 ? 1 : 0
				this.$confirm('此操作将改变该制度的状态, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						// setFlag({ id: id, isFlag: _flag })
						setAgreementStatusPt({ id: row.id, isFlag: _flag })
							.then((res) => {
								if (res.code === 0) {
									this.$message.success(res.msg)
									row.isFlag = _flag
								}
							})
							.catch((err) => {})
					})
					.catch(() => {
						this.$message.info('已取消操作！')
					})
			} else {
				this.$message.warning('当前账号没权限进行此操作！')
			}
		},

		// 点击新增
		doAdd() {
			this.dialogObj.title = '新增平台制度'
			this.dialogObj.mode = 'add'
			this.ruleForm.id = this.$SnowFlake.nextId()
			this.dialogObj.visible = true
		},

		// 点击编辑
		doEdit(row) {
			let obj = Object.assign({}, row)
			obj.applyRoleList = obj.applyRole.split(',')
			obj.applySysList = obj.applySys.split(',')
			this.dialogObj.title = '编辑'
			this.dialogObj.mode = 'edit'
			this.dialogObj.visible = true

			this.ruleForm = obj
			// 触发applySysList 清空事件了 ，roleList 没了
			setTimeout(() => {
				this.ruleForm.applyRoleList = this.ruleForm.applyRole.split(',')
			}, 500)
		},

		// 点击删除
		doDelete(row) {
			if (row.isFlag == 1) {
				this.$message.error('启用的协议无法删除')
			} else {
				this.$confirm('确认删除该协议制度吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						// deleteRule({ id: row.id })
						deleteRegime({ id: row.id })
							.then((res) => {
								this.$message.success('删除成功！')
								this.doRefresh()
							})
							.catch((err) => {})
					})
					.catch(() => {})
			}
		},

		// 确认添加/编辑
		doSubmit() {
			let params = Object.assign({}, this.ruleForm)
			params.applyRole = params.applyRoleList.join(',')
			params.applySys = params.applySysList.join(',')
			params.newFlag = this.dialogObj.mode == 'add' ? 0 : 1
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					// saveRules(params)
					insertOrUpdateRegime(params)
						.then((res) => {
							this.$message.success(res.msg)
							this.dialogObj.visible = false
						})
						.catch((err) => {})
				} else {
					this.$message.warning('请填写必填项')
				}
			})
		},

		// 切换页码
		handlePageChange({ currentPage, pageSize }) {
			this.currentPage = currentPage
			this.pageSize = pageSize

			this.doSearch()
		},

		// 获取应用
		getRangeList() {
			getRange({})
				.then((res) => {
					this.rangeList = res.data
				})
				.catch((err) => {})
		},

		// 查询获得规则
		doSearch(type) {
			if (type && type == '1') {
				this.currentPage = 1
				this.pageSize = 10
			}
			this.tableData = []
			this.loading = true
			if (this.searchObj.dateArr && this.searchObj.dateArr.length > 0) {
				this.searchObj.startDate = this.searchObj.dateArr[0] + ' 00:00:00'
				this.searchObj.endDate = this.searchObj.dateArr[1] + ' 23:59:59'
			} else {
				this.searchObj.startDate = ''
				this.searchObj.endDate = ''
			}
			let params = {
				sname: this.searchObj.sname,
				type: this.searchObj.type,
				publisher: this.searchObj.publisher,
				startDate: this.searchObj.startDate,
				endDate: this.searchObj.endDate,
				current: this.currentPage,
				size: this.pageSize
			}
			// getRules(params)
			selectRegimePage(params)
				.then((res) => {
					this.loading = false
					// console.log(res)
					if (res.code === 0) {
						this.totalResult = parseInt(res.data.total)
						this.tableData = res.data.records
					}
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 点击刷新
		doRefresh() {
			this.$refs.searchForm.resetFields()
			this.searchObj.endDate = ''
			this.pageSize = 10
			this.currentPage = 1
			this.searchObj.dateArr = []
			this.doSearch()
		},

		// 关闭弹窗
		handleClosed() {
			this.ruleForm.id = ''
			this.ruleForm.sname = ''
			this.ruleForm.type = ''
			this.ruleForm.applySys = ''
			this.ruleForm.applySysList = []
			this.ruleForm.applyRole = ''
			this.ruleForm.applyRoleList = []
			this.ruleForm.content = ''

			this.doSearch()
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchObj.endDate
					if (endTime) {
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateBefore(time, endTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchObj.startDate
					if (startTime) {
						let nowTime = Date.now()
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		}
	},
	computed: {
		...mapState('dict', {
			xyzdlx: (state) => state.projectDict.xyzdlx || []
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		// 制度类型
		rulesList() {
			let arr = [{ sname: '协议制度', value: '', children: [] }]
			this.xyzdlx && this.xyzdlx.length > 0 ? arr[0].children.push(...this.xyzdlx) : ''
			return arr
		},

		// 应用业务
		filterRange() {
			let arr = []
			this.ruleForm.applySysList.map((x) => {
				let _item = this.rangeList.find((y) => y.value === x)
				arr.push(_item)
			})
			return arr
		}
	},
	watch: {
		// 监听范围的变化
		// 'ruleForm.applySysList': {
		// 	handler: function (val) {
		// 		this.ruleForm.applyRoleList = []
		// 	},
		// 	deep: true,
		// },
		'ruleForm.content': {
			handler: function(val) {
				// console.log(val)
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.left-pane {
	padding: 10px;
}

.operation-header {
	justify-content: space-between;
	.title {
		// border-left: none;
		// padding-left: 0;
	}
}
.content-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
		padding-left: 10px;
		border-left: 4px solid #2671cc;
		font-size: 14px;
		color: #202020;
	}
	.blue {
		font-size: 18px;
		color: #2671cc;
	}
}
.input-width {
	min-width: 250px;
}
.vxe-switch.is--disabled {
	opacity: 1;
	/deep/ .vxe-switch--button {
		cursor: pointer !important;
	}
}
/deep/ .is--on {
	.vxe-switch--button {
		background-color: #2671cc !important;
	}
}
.pd5 {
	padding: 0 5px;
}
</style>
